import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigPsimRequestParams } from 'app/models/configpsim.model';
import { AbConfigPsim } from 'app/abstract/full-pages/config-psim/config-psim.abstract';

@Injectable({ providedIn: 'root' })
export class ConfigPSIMService extends AbConfigPsim {

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfig(params?: ConfigPsimRequestParams): Observable<any> {
    return this.get(`config_psim/1`, null, params);
  }

  public getConfigPublic(params?: ConfigPsimRequestParams): Observable<any> {
    return this.get(`public/config_psim/1`, null, params);
  }

  public getConfigWebHook(): Observable<any> {
    return this.get(`config_psim/webhook`);
  }

  public testeConexao(obj: any): Observable<any> {
    return this.save(`config_psim/teste_conexao`, obj);
  }

  public salvar(obj: any): Observable<any> {
    return this.save(`config_psim/`, obj);
  }

  public desvincularConta(obj: any): Observable<any> {
    return this.save(`config_psim/desvincular_conta/`, obj);
  }

  public getContaPSIM(contaId: number): Observable<any> {
    return this.get(`config_psim/conta/${contaId}`);
  }

  public getContasPSIM(): Observable<any> {
    return this.get(`config_psim/contas/`);
  }

  public getDivisoesPSIM() {
    return this.get(`config_psim/blocos/`).toPromise().catch();
  }

  public getAllConfigAvancadasByTipo(tipo: string): Observable<any> {
    return this.get(`config_integracao/tipo/${tipo}`);
  }

  public salvarAvancadas(objs: any): Observable<any> {
    return this.save(`config_integracao/saveall/`, objs);
  }

  public salvarConfigGrupo(objs: any): Observable<any> {
    return this.save(`config_psim/perfis/save/`, objs);
  }

  public salvarSincronizarPessoas(objs: any): Observable<any> {
    return this.save(``, objs);
  }

  public getAllConfigAvancadas(): Observable<any> {
    return this.get(`config_integracao/all`);
  }

  public getAllPerfilAtivos() {
    return this.get(`config_psim/perfis`);
  }

  public getAllIntegracaoGrupoPerfil() {
    return this.get(`config_psim/integracao_grupo_perfil`);
  }

}
